import { computed } from 'vue';
import { useNutzInputStore } from '@/features/Sparten/nutz/useInputStore';
import type { ConditionalRequestDefinition } from '@/utils/dehydrateRequestData/types';
import {
  hasGefahrgut,
  hasGesamtewicht,
  hasLeistung,
  hasNeuwert,
} from '@/features/Sparten/shared/renderConditions/kfz/sharedRenderConditions';
import {
  hasGapDeckung,
  hasNoDamage,
  hasOneChild,
  hasSeveralChildren,
  isAnhaengerBauartAvailable,
  isAssistenzsystemAvailable,
  isAufbauartAvailable,
  isCompanyOrWorksInAutomotive,
  isErstbesitzer,
  isFahrerkreisAny,
  isFahrerkreisAvailable,
  isFahrerkreisFix,
  isFahrerkreisNoAgeRestriction,
  isFahrerkreisVNDriver,
  isFahrerschutzversicherungAvailable,
  isHaftpflicht,
  isJaehrlicheFahrleistungAvailable,
  isNoAbweichenderHalter,
  isNoMinors,
  isNoSaisonkennzeichen,
  isNoSaisonKennzeichen,
  isNotAnAdditionalCar,
  isNoTeilkasko,
  isNotGermanOrIsCompany,
  isNotHaftpflichtFeature,
  isNoVollkasko,
  isNoVorversicherung,
  isNutzungsartAvailable,
  isOnlyHaftpflichtFeature,
  isOnlyVollkaskoFeature,
  isRabattschutzKfzHaftpflichtAvailable,
  isRabattschutzKfzVollkaskoAvailable,
  isSfKlasseAvailable,
  isVnVorsteuerabzugsberechtigt,
  temporaryField,
} from '@/features/Sparten/shared/inputDehydration/kfz/conditionalRequestDefinitions';
import { hasNutzKilometerstand } from '@/features/Sparten/nutz/renderConditions';

const isFirma: ConditionalRequestDefinition = {
  if: computed(() => useNutzInputStore().versicherungsnehmer.isFirma),
  drop: [
    'anredeId',
    'geburtsdatum',
    'familienstand',
    'nationalitaet',
    'versicherungsnehmer.berufsstatus',
    'versicherungsnehmer.beruf',
    'versicherungsnehmer.speziellerArbeitgeber',
    'versicherungsnehmer.tarifgruppe',
    'versicherungsnehmer.hasMinderjaehrigeKinder',
    'versicherungsnehmer.minderjaehrigeKinder',
    'versicherungsnehmer.hasFuehrerscheinInEUErworben',
    'versicherungsnehmer.isMitarbeiterAutohersteller',
    'versicherungsnehmer.hasWohnsitzMin5JahreInBrd',
    'versicherungsnehmer.isVorsteuerAbzugsberechtigt',
    'versicherungsnehmer.mitgliedschaften',
    'versicherungsnehmer.fuehrerscheindatum',
  ],
};

const isKilometerstandAvailable: ConditionalRequestDefinition = {
  if: computed(() => !hasNutzKilometerstand.value),
  drop: ['fahrzeug.kilometerstand'],
};

const isGesamtgewichtAvailable: ConditionalRequestDefinition = {
  if: computed(() => !hasGesamtewicht.value),
  drop: ['fahrzeug.gesamtgewicht'],
};

const isLeistungAvailable: ConditionalRequestDefinition = {
  if: computed(() => !hasLeistung.value),
  drop: ['fahrzeug.leistung'],
};

const isNeuwertAvailable: ConditionalRequestDefinition = {
  if: computed(() => !hasNeuwert.value),
  drop: ['fahrzeug.neuwert'],
};

const isGefahrgutAvailable: ConditionalRequestDefinition = {
  if: computed(() => !hasGefahrgut.value),
  drop: ['fahrzeug.gefahrgut'],
};

export const nutzInputDehydrationDefinitions: ConditionalRequestDefinition[] = [
  isNoAbweichenderHalter,
  isErstbesitzer,
  isFirma,
  isCompanyOrWorksInAutomotive,
  isNotGermanOrIsCompany,
  isFahrerkreisVNDriver,
  isFahrerkreisFix,
  isFahrerkreisAny,
  isFahrerkreisNoAgeRestriction,
  isNoSaisonkennzeichen,
  isNotAnAdditionalCar,
  isNoVollkasko,
  isNoTeilkasko,
  isHaftpflicht,
  isNoSaisonKennzeichen,
  isNoMinors,
  isNoVorversicherung,
  hasOneChild,
  hasSeveralChildren,
  hasNoDamage,
  isOnlyHaftpflichtFeature,
  isNotHaftpflichtFeature,
  isOnlyVollkaskoFeature,
  hasGapDeckung,
  isVnVorsteuerabzugsberechtigt,
  isAnhaengerBauartAvailable,
  isAufbauartAvailable,
  isGesamtgewichtAvailable,
  isLeistungAvailable,
  isNeuwertAvailable,
  isJaehrlicheFahrleistungAvailable,
  isKilometerstandAvailable,
  isGefahrgutAvailable,
  isNutzungsartAvailable,
  isFahrerkreisAvailable,
  isAssistenzsystemAvailable,
  isSfKlasseAvailable,
  isFahrerschutzversicherungAvailable,
  isRabattschutzKfzHaftpflichtAvailable,
  isRabattschutzKfzVollkaskoAvailable,
  temporaryField,
];
